export default "<p>simple-api-list works!</p>\n"